export class ActionResponse {
  ActionID: number;
  Name: string;
  Description: string;
}
